import React from 'react';
import classNames from 'classnames';
import cls from './DraftbarLine.module.css';
import { useDraftbarLine } from './useDraftbarLine';
import { Icon } from '../../../../../../components/newUI/Icon/Icon';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

interface DraftbarLineProps {
    classes?: string;
    estimateId: number;
    estimateName: string;
    estimateStatus: string;
    estimateDate: string;
}

export const DraftbarLine = ({
    classes,
    estimateId,
    estimateName,
    estimateStatus,
    estimateDate,
}: DraftbarLineProps) => {
    const {} = useDraftbarLine();
    const { t } = useTranslation();
    return (
        <div className={classNames(cls.DraftbarLine, [classes])}>
            <div className={cls.LineStatus}>
                <Icon
                    iconName={'circle'}
                    fill={estimateStatus === 'draft' ? '#9DA1AC' : '#FB9D32'}
                />
            </div>
            <div className={cls.EstimateDate}>
                <a className={cls.LineLink} href={`/estimate/${estimateId}`}>
                    {estimateName}
                </a>
                <span className={cls.DateText}>
                    {t('DraftbarLine.return.DateText')} {moment(estimateDate).format('DD.MM.YYYY')}
                </span>
            </div>
        </div>
    );
};
